import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>VAT Calculator</h1>
        <p>Fast, accurate, and easy-to-use VAT calculator for businesses and individuals. Add or remove VAT with just one click!</p>
      </div>
    </section>
  );
};

export default Hero;
